import type { FooterNavigationApiModel } from '@gro-up/api/corporate'

export const useLayoutData = () => {
  const layoutData = inject<FooterNavigationApiModel>('layoutData')

  if (!layoutData) {
    throw createError({
      statusCode: 500,
      statusMessage: 'Layout Not Found',
    })
  }

  return layoutData
}
